import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import FilterNav from './FilterNav';
const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;
// Utility: Generate QuickChart.io chart URL
const getChartUrl = (data, label, clr = 'Data') => {
  if (!data || data.length === 0) return '';

  let chart_clr = '';
  if(clr > 0) {
  	chart_clr = 'green';
  }
  else {
  	chart_clr = 'red';
  }

  const chartData = {
    type: 'line',
    data: {
      labels: data.map((_, i) => i),
      datasets: [
        {
          label: label,
          data: data,
          borderColor: chart_clr,
          fill: false,
          borderWidth: 2,
          pointRadius: 0,
        },
      ],
    },
    options: {
      elements: { line: { tension: 0.4 } },
      plugins: { legend: { display: false } },
      scales: {
        x: { display: false },
        y: { display: false },
      },
    },
  };

  const encoded = encodeURIComponent(JSON.stringify(chartData));
  return `https://quickchart.io/chart?c=${encoded}`;
};

// Utility: Format numbers with commas
const formatNumber = (num) => {
  if (!num) return '-';
  return Intl.NumberFormat('en-US', { notation: 'compact' }).format(num);
};

const CACHE_DURATION = 60 * 1000 * 4; // 4 minute
const REFRESH_THRESHOLD = 60 * 1000; // 15 seconds

// Save to cache with expiry
const setCache = (key, data, ttl) => {
  const now = Date.now();
  const expiry = now + ttl;
  const item = { data, timestamp: now, expiry };
  localStorage.setItem(key, JSON.stringify(item));
};

// Load from cache and decide if it's fresh enough
const getCache = (key) => {
  const cached = localStorage.getItem(key);
  if (!cached) return null;

  const { data, timestamp, expiry } = JSON.parse(cached);
  const now = Date.now();

  if (now > expiry) {
    localStorage.removeItem(key);
    return null;
  }

  const isStale = now - timestamp > REFRESH_THRESHOLD;

  return { data, isStale };
};

const CoinTable = ({ coins, showBuyButton = true, showTimeframes, showMemeRank, activeTab }) => {
	const { pathname } = useLocation();
  return (
    <div className="table_mainsec">
      <div className="table-responsive">
        <table className="table" id="coin_list_table">
          <thead>
            <tr>
              <th>Coin</th>
							<th>Price</th>
							<th>24h Change</th>
							<th>Volume</th>
							<th>Chart</th>
            </tr>
          </thead>
          <tbody>
						{coins.length > 0 ? (
						  coins.map((coin) => (
						    <tr key={coin.id}>
						      <td>
						        <div className="coinnamebox">
						          <div className="logobox">
						            <img src={coin.image} alt={coin.name} />
						          </div>
						          <div className="coinname">
						            <div className="shortname">{coin.symbol}</div>
						            <div className="fullname">{coin.name}</div>
						          </div>
						        </div>
						      </td>

						      <td>
						        <div>
						          {(pathname === '/trending-coins' || activeTab === 'trending')
                			? `$${coin.price?.toLocaleString()}`
                			: `$${coin.current_price?.toLocaleString()}`}
						        </div>
						      </td>

						      <td>
						        <div className="changeinfo">
						          {coin.price_change_percentage_24h < 0 ? (
						            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="red">
						              <polyline points="2 7 10.5 15.5 15.5 10.5 22 17"></polyline>
						              <polyline points="8 17 2 17 2 11"></polyline>
						            </svg>
						          ) : (
						            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="green">
						              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
						              <polyline points="16 7 22 7 22 13"></polyline>
						            </svg>
						          )}

						          <span className={`percentage ${coin.price_change_percentage_24h < 0 ? 'red' : 'green'}`}>
						            {coin.price_change_percentage_24h != null
						              ? coin.price_change_percentage_24h.toLocaleString('en-US', {
						                  minimumFractionDigits: 2,
						                  maximumFractionDigits: 2,
						                }) + '%'
						              : 'N/A'}
						          </span>
						        </div>

						        <div className="price">
						          ${coin.total_volume.toLocaleString('en-US', {
						            minimumFractionDigits: 2,
						            maximumFractionDigits: 2,
						          })}
						        </div>
						      </td>

						      <td>
						        ${coin.total_volume.toLocaleString('en-US', {
						          minimumFractionDigits: 2,
						          maximumFractionDigits: 2,
						        })}
						      </td>

						      <td>
						        <div className="chartgraph">
						          <img
						            alt={coin.name}
						            src={`https://www.coingecko.com/coins/${coin.coin_id}/sparkline.svg`}
						          />
						        </div>
						      </td>
						    </tr>
						  ))
						) : (
						  <tr>
						    <td colSpan="5">No campaigns found</td>
						  </tr>
						)}
					</tbody>
        </table>
      </div>
    </div>   
  );
};

export default CoinTable;